import styled from "@emotion/styled";
import { ToggleButton, Typography } from "@kaltura/ds-react-components";
import { Truncate } from "@mediaspace/shared/ui";

export const InterestButton = styled(ToggleButton)<{ selected: boolean }>(
    ({ theme }) => ({
        maxWidth: 180,
        [theme.breakpoints.up("sm")]: {
            maxWidth: 260,
        },
    })
);

export const TruncatedContent = styled(Truncate)(({ theme }) => ({
    maxWidth: "544px",
    marginTop: theme.spacing(2),
}));

export const Content = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flexWrap: "wrap",
    gap: theme.spacing(1),
}));

export const Counter = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone3,
}));

// A line with the counter and the "more items" label
export const CounterAndMoreItemsLine = styled("div")({
    display: "flex",
    alignItems: "center",
    "> :first-of-type": {
        flex: 1,
    },
});

// A line with the counter only - displayed when the tags are not truncated
// (otherwise, the counter will be in the line of the "more"/"less" button)
export const CounterLine = styled("div")(({ theme }) => ({
    marginTop: theme.spacing(1),
}));

export const Instruction = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone2,
    margin: theme.spacing(2, 0),
}));
